import createWrapper from 'components/Common/op-ui-wrappers/createWrapper';

type Variant = 'display' | 'headline' | 'title' | 'body' | 'label' | 'body-special';
type Size = 'small' | 'medium' | 'large';
type Weight = 'light' | 'regular' | 'medium' | 'bold' | 300 | 400 | 500 | 700;
export type TextVariant = `${Variant}-${Size}-${Weight}`;

export interface TextElement extends HTMLElement {
  paragraph?: boolean;
  block?: boolean;
  variant?: TextVariant | Variant;
  size?: Size;
  weight?: Weight;
}

const OpText = createWrapper<TextElement>('op-text');

export default OpText;
